"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _BasicStatus = _interopRequireDefault(require("./BasicStatus"));

var _NewStatus = _interopRequireDefault(require("./NewStatus"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Security(_ref) {
  var _data$status$name, _data$status, _data$lastAttempt;

  var data = _ref.data,
      inProcess = _ref.inProcess;
  var statusType = (_data$status$name = data === null || data === void 0 ? void 0 : (_data$status = data['status']) === null || _data$status === void 0 ? void 0 : _data$status['name']) !== null && _data$status$name !== void 0 ? _data$status$name : null;
  var lastAttempt = (_data$lastAttempt = data === null || data === void 0 ? void 0 : data['lastAttempt']) !== null && _data$lastAttempt !== void 0 ? _data$lastAttempt : null;

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block'],
      "data-locator": 'options.identification'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__title'],
      "data-locator": 'options.identification.title'
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'section'
    }, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F")), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__content']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__column']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__field-title'],
      "data-locator": 'options.identification.subtitle'
    }, "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438"), !statusType && /*#__PURE__*/_react["default"].createElement(_storybook.Text, null, "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"), statusType === 'Basic' && /*#__PURE__*/_react["default"].createElement(_BasicStatus["default"], null), statusType === 'New' && /*#__PURE__*/_react["default"].createElement(_NewStatus["default"], {
      inProcess: inProcess,
      data: lastAttempt
    }))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Security;
exports["default"] = _default;